import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import {withAppContext} from "../../util/withAppContext";

class DeveloperTypeFormTable extends EnlilTable {
}

export default withNavigate(withAppContext(DeveloperTypeFormTable));